import { IBookableDatesInfo } from "@/domain/entities/book";
import { injectable } from "inversify";

export interface HasFullyBookedDateUseCase {
  execute(bookableDates: IBookableDatesInfo[]): boolean;
}

@injectable()
export class HasFullyBookedDate implements HasFullyBookedDateUseCase {
  execute(bookableDates: IBookableDatesInfo[]): boolean {
    return bookableDates.some((bookableDate) =>
      bookableDate.bookableDates.some((date) => date.remainingSeatsCount === 0)
    );
  }
}
